export default function pad(num) {
  return num < 10 ? `0${num}` : `${num}`;
}